import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import * as Icons from '@fortawesome/free-solid-svg-icons'

var fontAwesomeInitialized = false;

const Icon = ({ ...props }) => {
  if (!fontAwesomeInitialized) {
    fontAwesomeInitialized = true;
    const iconList = Object
      .keys(Icons)
      .filter(key => key !== "fas" && key !== "prefix")
      .map(icon => Icons[icon])

    library.add(...iconList);
  }

  return <FontAwesomeIcon icon={props.name}/>
};

export default Icon;
